var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 9.16658H11.3333V4.16659C11.3333 3.94557 11.2455 3.73361 11.0892 3.57733C10.9329 3.42105 10.7209 3.33325 10.4999 3.33325C10.2789 3.33325 10.0669 3.42105 9.91066 3.57733C9.75438 3.73361 9.66658 3.94557 9.66658 4.16659V9.16658H4.66659C4.44557 9.16658 4.23361 9.25438 4.07733 9.41066C3.92105 9.56694 3.83325 9.7789 3.83325 9.99992C3.83325 10.2209 3.92105 10.4329 4.07733 10.5892C4.23361 10.7455 4.44557 10.8333 4.66659 10.8333H9.66658V15.8333C9.66658 16.0543 9.75438 16.2662 9.91066 16.4225C10.0669 16.5788 10.2789 16.6666 10.4999 16.6666C10.7209 16.6666 10.9329 16.5788 11.0892 16.4225C11.2455 16.2662 11.3333 16.0543 11.3333 15.8333V10.8333H16.3333C16.5543 10.8333 16.7662 10.7455 16.9225 10.5892C17.0788 10.4329 17.1666 10.2209 17.1666 9.99992C17.1666 9.7789 17.0788 9.56694 16.9225 9.41066C16.7662 9.25438 16.5543 9.16658 16.3333 9.16658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.02bd5e33ea5a704ae340f5abce8f2f0a.svg";
export { ForwardRef as ReactComponent };